import {Typography} from '@mui/material';
import {getCommissionPayable} from 'Agent/Commissions/ducks/a360Commissions';
import {isAsyncServerError} from 'Core/models/Async';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {renderAsyncView} from 'Shared/components/RenderAsync';
import {formatCurrency} from 'Shared/utilities/FormatMoney';
import './Commissions.scss';
import {A360CommissionSection} from '../CommissionSection';
import {A360CommissionsSectionError, A360CommissionsSectionNoRecordsFound, LoadingSpinner} from '../Placeholders';

export const CommissionPayable = () => {
  const {commissionPayable} = useSelector((state: ReducerState) => state.a360Commissions);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCommissionPayable());
  }, []);

  return (
    <A360CommissionSection
      title="Commission Payable"
      align="center"
      className="a360-commissions__commission-payable"
      withSeparator
      aria-label="commission payable"
    >
      {isAsyncServerError(commissionPayable) ? (
        <A360CommissionsSectionError error={commissionPayable.errorDetails} />
      ) : (
        renderAsyncView(
          commissionPayable,
          value =>
            value ? (
              <Typography sx={{fontSize: '2.25rem', fontWeight: 700}}>{formatCurrency(value)}</Typography>
            ) : (
              <A360CommissionsSectionNoRecordsFound />
            ),
          LoadingSpinner
        )
      )}
    </A360CommissionSection>
  );
};
